import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import Logo from '@/components/Logo'
import AuthBackgroundShape from '@/components/AuthBackgroundShape'

const EmailConfirmationPage = () => {
  return (
    <div className='relative flex h-auto min-h-screen items-center justify-center overflow-x-hidden px-4 py-10 sm:px-6 lg:px-8'>
      <div className='absolute'>
        <AuthBackgroundShape />
      </div>

      <Card className='z-1 w-full border-none shadow-md sm:max-w-lg'>
        <CardHeader className='gap-6'>
          <div className='flex justify-center'>
            <Logo className='gap-3' showText={false} />
          </div>

          <div className='flex flex-col items-center text-center'>
            <CardTitle className='mb-1.5 text-2xl'>Check your email</CardTitle>
            <CardDescription className='text-base'>
              We've sent a confirmation link to your email address.
            </CardDescription>
          </div>
        </CardHeader>

        <CardContent className='space-y-4'>
          <div className='rounded-lg bg-muted p-4 text-center'>
            <p className='text-sm text-muted-foreground'>
              Please click the confirmation link in the email to activate your account. Once confirmed, you'll be able
              to sign in to Fenra.
            </p>
          </div>

          <div className='space-y-2 text-center text-sm text-muted-foreground'>
            <p>Didn't receive the email? Check your spam folder.</p>
            <p>
              If you still need help, please{' '}
              <a href='mailto:ajdin@fenra.io' className='text-card-foreground hover:underline'>
                contact support
              </a>
              .
            </p>
          </div>

          <Button className='w-full' asChild>
            <Link to='/auth/login'>Back to Login</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}

export default EmailConfirmationPage

